module.exports = __webpack_public_path__ + "img/icon_process2.a5bf04d5.png";